import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { QRCodeModule } from 'ng-qrcode';
import { NgxPaginationModule } from 'ngx-pagination';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { PaPanelComponent } from './components/papanel/papanel.component';
import { PaHeaderComponent } from './components/header/header.component';
import { PaCasesComponent } from './components/cases/cases.component';
import { PaOtherComponent } from './components/other/other.component';
import { PaFeedbackComponent } from './components/feedback/feedback.component';
import { PaSurveyComponent } from './components/survey/survey.component';
import { PaAppointmentComponent } from './components/appointment/appointment.component';
import { PaBookComponent } from './components/book/book.component';
import { PaProfileSettingsComponent } from './components/paprofile-settings/paprofile-settings.component';
import { PatientServiceService } from './services/PatientService.service';
import { PatientAppointmentService } from './services/PatientAppointment.service';
import { SurveyServiceService } from './services/SurveyService.service';
import { TokenExpireInterceptor } from '../../core/TokenExpireInterceptor.interceptor';
import { ScheduleModule, AgendaService, DayService, WeekService, WorkWeekService, MonthService, TimelineViewsService, TimelineMonthService } from '@syncfusion/ej2-angular-schedule';
import { PaStarRatingComponent } from './components/pa-star-rating/pa-star-rating.component';
import { PaBookAppointmentDoctorPipePipe } from './pipes/PaBookAppointmentDoctor.pipe';
import { PaBookAppointmentCasePipePipe } from './pipes/PaBookAppointmentCase.pipe';
import { PaConfirmpasswordDirectiveDirective } from './directives/PaConfirmPasswordDirective.directive';
import { PAROUTING } from './PaRouting.module';
import { SharedModule} from '../shared/shared.module';
import { PatientFeedbackCardComponent } from './components/elements/patient-feedback-card/patient-feedback-card.component';
import { PatientBookCardComponent } from './components/elements/patient-book-card/patient-book-card.component';
import { PatientAppointmentCardComponent } from './components/elements/patient-appointment-card/patient-appointment-card.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    QRCodeModule,
    ScheduleModule,
    NgxPaginationModule,
    InfiniteScrollModule,
    PAROUTING,
    SharedModule
  ],
  providers: [PatientServiceService, PatientAppointmentService, SurveyServiceService,
    AgendaService, DayService, WeekService, WorkWeekService, MonthService, TimelineViewsService, TimelineMonthService,

    {
    provide: HTTP_INTERCEPTORS,
    useClass: TokenExpireInterceptor,
    multi: true
  },],
  declarations: [
    PaPanelComponent,
    PaHeaderComponent,
    PaCasesComponent,
    PaOtherComponent,
    PaFeedbackComponent,
    PaSurveyComponent,
    PaAppointmentComponent,
    PaBookComponent,
    PaProfileSettingsComponent,
    PaStarRatingComponent,
    PaBookAppointmentDoctorPipePipe,
    PaBookAppointmentCasePipePipe,
    PaConfirmpasswordDirectiveDirective,
    PatientFeedbackCardComponent,
    PatientBookCardComponent,
    PatientAppointmentCardComponent,

  ]
})
export class PaModuleModule { }
